import ReactS3Client from "react-aws-s3-typescript";

export const S3_BUCKET = "deliceo-formace-app-v2-upload";
export const REGION = "eu-west-3";
export const ACCESS_KEY = "AKIA3AYWASJ2D3RSZ25X";
export const SECRET_ACCESS_KEY = "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";

const s3Config = {
  bucketName: S3_BUCKET,
  region: REGION,
  accessKeyId: ACCESS_KEY,
  secretAccessKey: SECRET_ACCESS_KEY,
};

export default s3Config;

export const uploadFileOnAWS = (dirName: string, file: File) => {
  const s3 = new ReactS3Client({
    ...s3Config,
    dirName,
  });

  return s3.uploadFile(file);
};
